var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
    src: _vm.data.bg,
  }),expression:"{\n    src: data.bg,\n  }",arg:"background-image"}],staticClass:"templateThree",style:({ backgroundColor: _vm.data.bgColor })},[_c('title-widge',{attrs:{"title":_vm.data.title,"titleColor":_vm.titleColor,"fontBg":_vm.fontBg}}),_c('div',{staticClass:"divImg"},[_c('img',{staticClass:"divImg",attrs:{"src":_vm.data.url}}),_c('div',{staticClass:"divDesc"},[_vm._v(_vm._s(_vm.data.desc))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }